export enum CashlessPaymentProviderEventType {
  PaymentInProgress,
  TextChanged,
  PaymentCompleted,
  PaymentAborted
}
